export default {
  getAddress: (state) => state.address,
};
